import { IPublicClientApplication } from "@azure/msal-browser";
import {
    Button,
    Grid,
    useMediaQuery,
    useTheme,
} from "@valenzinsights/core-component";
import { ValenzLogoIconSvg } from "@valenzinsights/images";
import { InitializeMsalInstance, login } from "@valenzinsights/services";

export function Login({ instance }: { instance: IPublicClientApplication }) {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

	const handleLogIn = (e: any) => {
		try {
			InitializeMsalInstance(instance);
			login(instance);
		} catch (err) {
			console.log(err);
		}
	};

	return (
		<Grid container sx={{ height: "100%" }}>
			<Grid
				item
				xs={12}
				md={6}
				sx={{
					background: "#fff",
					height: isSmallScreen ? "50%" : "100%",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
				className="leftImg"
			>
				<img
					src={require("../images/valenzLogin.png")}
					style={{ height: "100%", width: "100%", objectFit: "cover" }}
					alt="logo"
				/>
			</Grid>
			<Grid
				item
				xs={12}
				md={6}
				sx={{
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
					flexDirection: "column",
					backgroundColor: "#F2F7FA",
					position: "relative",
					height: isSmallScreen ? "50%" : "100%",
				}}
			>
				<img src={ValenzLogoIconSvg} width="200px" alt="logo" />
				<Button
					variant="contained"
					size="large"
					sx={{ width: "330px", height: "40px", m: isSmallScreen ? 2 : 8 }}
					onClick={handleLogIn}
				>
					Login
				</Button>
				<p
					style={{
						position: "absolute",
						right: 0,
						bottom: "10px",
						left: 0,
						textAlign: "center",
						margin: "0px auto",
					}}
				>
					Copyright © 2024-2025 Valenz Health. All rights reserved.
				</p>
			</Grid>
		</Grid>
	);
}
